import styled from 'styled-components';

const FlexBox = styled.div`
	display: flex;

	${props => (props?.justifyEnd && 'justify-content: flex-end;')}
`;

export default FlexBox;
